import React from 'react'
import { Col, Dropdown, DropdownButton, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarPlus } from '@fortawesome/free-solid-svg-icons';

const EventHeader = (props) => {
    const { eventType, handleSwitchType, setShowEventModal, viewEventID, type } = props;

    return (
        <Row>
            {!viewEventID &&
                <Col>
                    <DropdownButton
                        id="custom-dropdown"
                        title={eventType}
                        onSelect={handleSwitchType}
                        variant="info"
                        style={{ width: '100%', marginBottom: '10px', float: 'right' }}
                        className="full-width-dropdown"
                    >
                        <Dropdown.Item eventKey={'Seasons'} style={{ width: '100%' }}>Seasons</Dropdown.Item>
                        <Dropdown.Item eventKey={"Live Events"}>Live Events</Dropdown.Item>
                        <Dropdown.Item eventKey={"Virtual Events"}>Virtual Events</Dropdown.Item>
                        <Dropdown.Item eventKey={"All Events"}>All Events</Dropdown.Item>
                    </DropdownButton>

                </Col>
            }
            {type === 'admin' && !viewEventID &&
                <Col xs={12} md={4}>

                    <button className="white-glow-button" onClick={() => setShowEventModal(true)} type="submit"
                        style={{
                            float: 'right', marginBottom: '20px', paddingTop: '5px',
                            paddingBottom: '5px', width: '100%'
                        }}>
                        <FontAwesomeIcon icon={faCalendarPlus} style={{ marginRight: '10px' }} /> Add New Event
                    </button>

                </Col>
            }
        </Row>
    )
}

export default EventHeader